import type { ExecutionContext } from 'styled-components'
import { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomColorProps = {
  accent?: boolean
  disabled?: boolean
  primary?: boolean
  secondary?: boolean
}

const accentCss = ({ accent }: ExecutionContext & { accent?: boolean }) =>
  accent &&
  css`
    color: ${themeGet('colors.primary.main')};
  `

const disabledCss = ({ disabled }: ExecutionContext & { disabled?: boolean }) =>
  disabled &&
  css`
    color: ${themeGet('colors.text.disabled')};
  `

const primaryCss = ({ primary }: ExecutionContext & { primary?: boolean }) =>
  primary &&
  css`
    color: ${themeGet('colors.text.primary')};
  `

const secondaryCss = ({
  secondary,
}: ExecutionContext & { secondary?: boolean }) =>
  secondary &&
  css`
    color: ${themeGet('colors.text.secondary')};
  `

export type { CustomColorProps }
export { accentCss, disabledCss, primaryCss, secondaryCss }
